import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  EVENTS_WIZARD_LINK: `${cleanedFilename(__filename)}-events-wizard-link`,
};
